export interface Category {
  name: string;
  url: string;
  imageUrl: string;
  isSearch?: boolean;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Casual%20leather%20sneakers%20and%20loafers%20arranged%20on%20a%20light%20sand%20colored%20linen%20fabric%20surface%2C%20soft%20morning%20daylight%20from%20left%20side%2C%20minimalist%20editorial%20product%20photography%2C%20subtle%20fabric%20texture%20visible%2C%20warm%20neutral%20cream%20backdrop%2C%20professional%20ecommerce%20styling%20with%20gentle%20shadows%20and%20organic%20composition&width=800&height=1067&seq=cat-shoes-v2-a1&orientation=portrait",
  },
  {
    name: "Hoodies & Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Oversized%20cozy%20knit%20sweaters%20and%20fleece%20hoodies%20draped%20across%20a%20light%20oak%20wooden%20surface%2C%20soft%20diffused%20window%20light%2C%20Scandinavian%20minimal%20aesthetic%2C%20visible%20textile%20weave%20detail%20and%20ribbed%20textures%2C%20warm%20oatmeal%20and%20cream%20tones%2C%20clean%20editorial%20fashion%20composition%20with%20relaxed%20draping&width=800&height=1067&seq=cat-hoodies-v2-b2&orientation=portrait",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20heavyweight%20cotton%20tshirts%20in%20neutral%20earth%20tones%20neatly%20stacked%20on%20a%20light%20stone%20textured%20surface%2C%20soft%20overhead%20natural%20light%2C%20minimalist%20product%20display%2C%20visible%20fabric%20density%20and%20stitching%20detail%2C%20warm%20sandstone%20cream%20backdrop%2C%20professional%20catalog%20photography%20with%20clean%20geometric%20arrangement&width=800&height=1067&seq=cat-tshirts-v2-c3&orientation=portrait",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20bomber%20jackets%20and%20denim%20jackets%20hanging%20on%20minimalist%20wooden%20wall%20hooks%20against%20a%20light%20cream%20plaster%20wall%2C%20soft%20afternoon%20sunlight%20streaming%20diagonally%2C%20modern%20urban%20aesthetic%2C%20premium%20fabric%20and%20hardware%20details%20visible%2C%20warm%20ivory%20beige%20backdrop%2C%20editorial%20fashion%20photography%20with%20shadow%20play&width=800&height=1067&seq=cat-jackets-v2-d4&orientation=portrait",
  },
  {
    name: "Pants & Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Well%20tailored%20chinos%20and%20casual%20linen%20shorts%20arranged%20flat%20on%20a%20light%20clay%20colored%20ceramic%20tile%20surface%2C%20soft%20natural%20ambient%20lighting%2C%20minimalist%20menswear%20aesthetic%2C%20visible%20fabric%20weave%20and%20pocket%20stitching%2C%20warm%20terracotta%20cream%20palette%2C%20professional%20garment%20flatlay%20photography%20with%20clean%20spacing&width=800&height=1067&seq=cat-pants-v2-e5&orientation=portrait",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashionable%20baseball%20caps%20and%20wide%20brim%20hats%20displayed%20on%20light%20colored%20wooden%20display%20stands%2C%20soft%20studio%20ring%20light%20illumination%2C%20clean%20modern%20streetwear%20aesthetic%2C%20fabric%20brim%20curves%20and%20embroidered%20details%20visible%2C%20warm%20sand%20cream%20background%2C%20professional%20accessory%20photography%20with%20elegant%20shadow%20gradients&width=800&height=1067&seq=cat-headwear-v2-f6&orientation=portrait",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20two%20piece%20clothing%20sets%20elegantly%20displayed%20on%20a%20light%20cream%20textured%20paper%20backdrop%2C%20soft%20golden%20hour%20lighting%20from%20above%2C%20refined%20fashion%20editorial%20aesthetic%2C%20harmonious%20earth%20tone%20color%20matching%20visible%2C%20warm%20ivory%20beige%20background%2C%20luxury%20lookbook%20photography%20with%20artistic%20composition&width=800&height=1067&seq=cat-sets-v2-g7&orientation=portrait",
  },
  {
    name: "Underwear",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20basics%20neatly%20folded%20in%20a%20grid%20arrangement%20on%20a%20soft%20cream%20bamboo%20fiber%20mat%20surface%2C%20gentle%20diffused%20studio%20light%2C%20clean%20minimal%20intimate%20apparel%20aesthetic%2C%20visible%20soft%20fabric%20texture%20and%20elastic%20waistband%20detail%2C%20warm%20blush%20cream%20background%2C%20professional%20catalog%20photography%20with%20consistent%20spacing&width=800&height=1067&seq=cat-underwear-v2-h8&orientation=portrait",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Athletic%20mesh%20jerseys%20in%20vibrant%20colors%20displayed%20on%20a%20light%20grey%20cream%20concrete%20surface%2C%20bright%20studio%20lighting%20with%20rim%20highlights%2C%20energetic%20sportswear%20aesthetic%2C%20breathable%20fabric%20perforation%20and%20team%20graphics%20visible%2C%20warm%20neutral%20backdrop%2C%20professional%20sports%20apparel%20photography%20with%20dynamic%20angles&width=800&height=1067&seq=cat-jersey-v2-i9&orientation=portrait",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20accessories%20collection%20including%20watches%20bracelets%20and%20sunglasses%20scattered%20artfully%20on%20a%20light%20cream%20marble%20slab%20surface%2C%20soft%20diffused%20spotlight%20illumination%2C%20luxurious%20minimalist%20aesthetic%2C%20metallic%20reflections%20and%20leather%20textures%20visible%2C%20warm%20pearl%20cream%20background%2C%20high%20end%20editorial%20product%20photography&width=800&height=1067&seq=cat-accessories-v2-j10&orientation=portrait",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20backpacks%20and%20crossbody%20bags%20standing%20upright%20on%20a%20light%20cream%20canvas%20fabric%20surface%2C%20soft%20natural%20window%20light%20from%20front%2C%20modern%20casual%20aesthetic%2C%20canvas%20texture%20and%20zipper%20hardware%20details%20visible%2C%20warm%20oatmeal%20cream%20backdrop%2C%20professional%20bag%20photography%20with%20clean%20product%20arrangement&width=800&height=1067&seq=cat-bags-v2-k11&orientation=portrait",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Genuine%20leather%20belts%20rolled%20in%20concentric%20circles%20on%20a%20light%20cream%20suede%20fabric%20surface%2C%20soft%20directional%20studio%20light%20casting%20gentle%20shadows%2C%20refined%20minimalist%20aesthetic%2C%20leather%20grain%20texture%20and%20polished%20buckle%20detail%20visible%2C%20warm%20taupe%20cream%20background%2C%20luxury%20product%20photography%20with%20elegant%20composition&width=800&height=1067&seq=cat-belts-v2-l12&orientation=portrait",
    isSearch: true,
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottles%20with%20amber%20and%20clear%20liquids%20arranged%20on%20a%20light%20cream%20travertine%20stone%20surface%2C%20soft%20backlit%20studio%20illumination%20creating%20glow%20through%20glass%2C%20sophisticated%20luxury%20aesthetic%2C%20light%20refraction%20and%20cap%20metallic%20details%20visible%2C%20warm%20champagne%20cream%20background%2C%20high%20end%20fragrance%20photography&width=800&height=1067&seq=cat-perfumes-v2-m13&orientation=portrait",
    isSearch: true,
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Eclectic%20mix%20of%20lifestyle%20items%20including%20notebooks%20headphones%20and%20small%20accessories%20arranged%20on%20a%20light%20cream%20cork%20board%20surface%2C%20soft%20overhead%20ambient%20light%2C%20organized%20creative%20chaos%20aesthetic%2C%20varied%20material%20textures%20visible%2C%20warm%20biscuit%20cream%20background%2C%20modern%20lifestyle%20product%20photography%20with%20balanced%20composition&width=800&height=1067&seq=cat-other-v2-n14&orientation=portrait",
    isSearch: true,
  },
];

export const faqData = [
  {
    question: "What is OOPBuy spreadsheet used for?",
    answer: "The OOPBuy spreadsheet is used for organizing product sourcing data, comparing listings, and accessing structured product information across multiple categories including shoes, hoodies, jackets, and accessories.",
  },
  {
    question: "Is OOPBuy spreadsheet free?",
    answer: "Many OOPBuy spreadsheet resources are free to access, but availability depends on the provider and the specific data categories you need. Some premium listings may require special access.",
  },
  {
    question: "Is OOPBuy spreadsheet legit?",
    answer: "The OOPBuy spreadsheet is a data organization tool designed to help users navigate product sourcing information efficiently. Its reliability depends on the source maintaining updated and verified information.",
  },
  {
    question: "How often is OOPBuy spreadsheet updated?",
    answer: "Most OOPBuy spreadsheet systems are updated regularly, with new product listings, category refinements, and data verification happening on a consistent basis depending on the data provider or community maintenance cycle.",
  },
  {
    question: "What is the alternative to OOPBuy spreadsheet?",
    answer: "Alternatives include manual product sourcing research, supplier databases, or other spreadsheet-based product tracking systems. However, the OOPBuy spreadsheet offers a uniquely structured and organized approach.",
  },
];

export const comparisonData = [
  {
    feature: "Data Structure",
    oopbuy: "Organized Spreadsheet System",
    manual: "Unstructured Notes",
    advantage: "oopbuy",
  },
  {
    feature: "Access Speed",
    oopbuy: "Instant Category Navigation",
    manual: "Time-Consuming Search",
    advantage: "oopbuy",
  },
  {
    feature: "Update Frequency",
    oopbuy: "Regularly Maintained",
    manual: "Inconsistent Updates",
    advantage: "oopbuy",
  },
  {
    feature: "Data Accuracy",
    oopbuy: "Verified & Cross-Referenced",
    manual: "Medium Reliability",
    advantage: "oopbuy",
  },
  {
    feature: "Ease of Use",
    oopbuy: "Beginner-Friendly Interface",
    manual: "Requires Experience",
    advantage: "oopbuy",
  },
  {
    feature: "Overall Efficiency",
    oopbuy: "High Performance",
    manual: "Low Efficiency",
    advantage: "oopbuy",
  },
];